/* eslint no-else-return: ["off"] */
import store from '@/store';
import { configAxios } from '@/axios/config';
// import axios from '@/axios';

const baseURL = process.env.VUE_APP_ORIGIN || window.location.origin;

async function guardAuth(to, from, next) {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    try {
      await store.dispatch('loadCurrentUser');
      if (!store.getters.currentUser && !window.location.href.includes('/login')) {
        window.location.href = `${baseURL}/login`;
        return;
      }
      configAxios();
      return next();
    } catch (error) {
      if (!error.response) {
        window.location.href = `${baseURL}/login`;
      }
      if (error.response && error.response.status === 401 && !window.location.href.includes('/login')) {
        window.location.href = `${baseURL}/login`;
      }
      await store.dispatch('setIsCurrentUserLoading', false);
    }
  } else {
    return next();
  }
}

export {
  guardAuth,
};
